import { createFileRoute } from '@tanstack/react-router';
import { CampaignMetricsRouteView } from '@/pages/workspaces/automations/[campaignId]/metrics/routing';

function CampaignMetricsRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignMetricsRouteView campaignId={campaignId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/metrics',
)({
  component: CampaignMetricsRoute,
});
